(function() {
  'use strict';

  function updateBundle(section) {
    var items = Array.from(section.querySelectorAll('.item-line[data-variant-id]'));
    var price = 0;
    var comparePrice = 0;
    items.forEach(function(item) {
      var itemPrice = Number(item.dataset.price) || 0;
      price += itemPrice;
      comparePrice += Math.max(Number(item.dataset.itemComparePrice) || itemPrice, itemPrice);
    });
    var onSale = comparePrice > price;
    var money = theme.Currency.formatProductMoney;
    function html(selector, value) {
      section.querySelectorAll(selector).forEach(function(el) { el.innerHTML = value; });
    }
    function hidden(selector, hide) {
      section.querySelectorAll(selector).forEach(function(el) { el.classList.toggle('hide', hide); });
    }
    html('[data-product-price], .price.navbar:not(.void)', money(price, true));
    html('[data-compare-price], .price.navbar.void', money(comparePrice));
    hidden('[data-product-price-wrap], .price.navbar.void, [data-save-price]', !onSale);
    section.querySelectorAll('[data-product-price]').forEach(function(el) {
      el.classList.toggle('on-sale', onSale);
    });
    section.querySelectorAll('[data-compare-price-a11y], [data-a11y-price]').forEach(function(el) {
      el.setAttribute('aria-hidden', String(!onSale));
    });
    var savings = comparePrice - price;
    var savedAmount = theme.settings.saveType === 'percent' && comparePrice > 0
      ? Math.round(savings * 100 / comparePrice) + '%'
      : money(savings);
    html('[data-save-price]', onSale ? theme.strings.savePrice.replace('[saved_amount]', savedAmount) : '');

    // Coupon displays must also use the remaining pieces, never the set variant.
    html('.coupon-price-original', money(price));
    section.querySelectorAll('[data-auto-coupon-price]').forEach(function(el) {
      var discounted = Math.round(price * (1 - Number(el.dataset.couponDiscount) / 100));
      var format = theme.settings.moneyFormat.replace(/\s*MXN\b/g, '');
      if (discounted % 100) format = format.replace('amount_no_decimals', 'amount');
      el.innerHTML = theme.Currency.formatMoney(discounted, format).replace(/\s*MXN\b/g, '') + ' MXN';
    });
    html('.set-prints-included', items.length + ' Cuadros');
    html('.sterframe-included', items.length + ' Marcos');
    html('[data-buy-type="set"] [data-add-to-cart-text], #productBarButton',
      'Agregar ' + items.length + (items.length === 1 ? ' pieza' : ' piezas') + ' al carrito');
    section.querySelectorAll('[data-buy-type="set"]').forEach(function(button) {
      button.disabled = items.length === 0 || button.dataset.bundleInitiallyDisabled === 'true';
    });
  }

  function initBundle(section) {
    if (section.dataset.bundleInitialized) return;
    section.dataset.bundleInitialized = 'true';
    section.querySelectorAll('[data-buy-type="set"]').forEach(function(button) {
      button.dataset.bundleInitiallyDisabled = String(button.disabled);
    });
    updateBundle(section);
    section.addEventListener('click', function(event) {
      var remove = event.target.closest('.set-line.delete');
      if (remove && event.target.closest('.tool-tip-trigger')) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (remove && !event.target.closest('.tool-tip-trigger')) {
        event.preventDefault();
        event.stopPropagation();
        var item = remove.closest('.item-line');
        var link = item.closest('a');
        (link || item).remove();
        updateBundle(section);
      }
      var button = event.target.closest('[data-buy-type="set"]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      var items = Array.from(section.querySelectorAll('.item-line[data-variant-id]')).map(function(item) {
        return { id: item.dataset.variantId, quantity: 1 };
      });
      if (!items.length) return;
      button.disabled = true;
      var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw new Error(data.description || 'No se pudo agregar el set.');
          return data;
        });
      }).then(function() {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
      }).catch(function(error) {
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          bubbles: true, detail: { error: error.message }
        }));
      }).finally(function() { updateBundle(section); });
    });
  }

  // Each request has its own Liquid lookup budget, even on large collections.
  var requests = new Map();
  var queue = [];
  var active = 0;
  function drain() {
    while (active < 4 && queue.length) {
      active++;
      queue.shift()().finally(function() { active--; drain(); });
    }
  }
  function requestPrice(path) {
    if (!requests.has(path)) {
      requests.set(path, new Promise(function(resolve, reject) {
        queue.push(function() {
          var url = new URL(path, window.location.origin);
          url.searchParams.set('section_id', 'bundle-card-price');
          var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          return fetch(url.toString()).then(function(response) {
            if (!response.ok) throw new Error('Set price unavailable');
            return response.text();
          }).then(function(markup) {
            var result = new DOMParser().parseFromString(markup, 'text/html')
              .querySelector('[data-bundle-card-result]');
            if (!result) throw new Error('Incomplete set configuration');
            resolve(result);
          }).catch(reject);
        });
        drain();
      }));
    }
    return requests.get(path);
  }
  function initCards() {
    document.querySelectorAll('[data-bundle-card-price]:not([data-price-state])').forEach(function(card) {
      card.dataset.priceState = 'loading';
      card.setAttribute('aria-busy', 'true');
      requestPrice(card.dataset.bundleCardPrice).then(function(result) {
        card.innerHTML = result.innerHTML;
        card.dataset.priceState = 'ready';
        var badge = card.closest('.grid-product').querySelector('[data-bundle-sale-tag]');
        if (badge) badge.classList.toggle('hide', result.dataset.onSale !== 'true');
      }).catch(function() {
        // The existing product link remains usable; never promise a stale total.
        card.dataset.priceState = 'error';
      }).finally(function() { card.removeAttribute('aria-busy'); });
    });
  }
  function init() {
    document.querySelectorAll('[data-bundle-product]').forEach(initBundle);
    initCards();
  }
  init();
  // Collection filters, recommendations, quick views and editor section reloads.
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
})();
